/**
 * @file ui控制
 * @author mengchen <mengchen@babytree-inc.com>
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Loading as LoadingComponent } from '../components/Loading';

export const Loading = {
  isOpen: false,
  parentDom: undefined,
  loadingDom: undefined,
  open(props) {
    if (this.isOpen) return;
    this.parentDom = document.createElement('div');
    document.body.appendChild(this.parentDom);
    this.loadingDom = React.createRef();
    ReactDOM.render(
      <LoadingComponent
        {...props}
        loading={true}
        ref={ref => {
          this.loadingDom = ref;
        }}
      />,
      this.parentDom,
      () => {
        this.isOpen = true;
      }
    );
    return this.close;
  },
  close() {
    if (!this.isOpen) return;
    this.loadingDom.className =
      `${this.loadingDom.className  } components-loading-out`;
    const timeout = window.setTimeout(() => {
      if (this.parentDom) {
        ReactDOM.unmountComponentAtNode(this.parentDom);
        this.parentDom.remove();
      }
      this.parentDom = undefined;
      this.loadingDom = undefined;
      this.isOpen = false;
      window.clearTimeout(timeout);
    }, 200);
  }
};
